<template>
  <v-app>
    <template v-if="!loading">
      <Header />

      <v-main class="primary lighten-2">
        <router-view />
      </v-main>

      <Footer />
    </template>
    <v-sheet
      v-else
      class="d-flex justify-center align-center primary"
      height="100%"
      width="100%"
      color="transparent"
    >
      <v-progress-circular
        :size="50"
        color="white"
        indeterminate
      ></v-progress-circular>
    </v-sheet>

    <CookieBanner></CookieBanner>
  </v-app>
</template>

<script>
import Header from "./components/shell/header/Index.vue";
import Footer from "./components/shell/Footer.vue";
import CookieBanner from "./components/widgets/CookieBanner.vue";

export default {
  data: () => ({
    loading: true,
  }),
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    name() {
      return this.informations.name || "";
    },
  },
  methods: {
    updateDocumentTitle() {
      document.title = !this.name
        ? this.$route.name
        : `${this.$route.name} - ${this.name}`;
    },
  },
  watch: {
    $route() {
      this.updateDocumentTitle();
    },
    name() {
      this.updateDocumentTitle();
    },
  },
  beforeCreate() {
    this.$rest("informations")
      .get({ save: (state, data) => (state.item = data) })
      .then(() => (this.loading = false));
  },
  created() {
    this.updateDocumentTitle();
  },
  components: {
    Header,
    Footer,
    CookieBanner,
  },
};
</script>

<style>
@font-face {
  font-family: "Futura";
  src: url("/fonts/FuturaBT-Light.eot");
  src: url("/fonts/FuturaBT-Light.eot?#iefix") format("embedded-opentype"),
    url("/fonts/FuturaBT-Light.woff2") format("woff2"),
    url("/fonts/FuturaBT-Light.woff") format("woff"),
    url("/fonts/FuturaBT-Light.ttf") format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Futura";
  src: url("/fonts/FuturaBT-Book.eot");
  src: url("/fonts/FuturaBT-Book.eot?#iefix") format("embedded-opentype"),
    url("/fonts/FuturaBT-Book.woff2") format("woff2"),
    url("/fonts/FuturaBT-Book.woff") format("woff"),
    url("/fonts/FuturaBT-Book.ttf") format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Futura";
  src: url("/fonts/Futura-Bold.eot");
  src: url("/fonts/Futura-Bold.eot?#iefix") format("embedded-opentype"),
    url("/fonts/Futura-Bold.woff2") format("woff2"),
    url("/fonts/Futura-Bold.woff") format("woff"),
    url("/fonts/Futura-Bold.ttf") format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Futura";
  src: url("/fonts/FuturaBT-Heavy.eot");
  src: url("/fonts/FuturaBT-Heavy.eot?#iefix") format("embedded-opentype"),
    url("/fonts/FuturaBT-Heavy.woff2") format("woff2"),
    url("/fonts/FuturaBT-Heavy.woff") format("woff"),
    url("/fonts/FuturaBT-Heavy.ttf") format("truetype");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}

a {
  cursor: default;
}

a:link,
.pointer {
  cursor: pointer;
}

.v-pagination .v-pagination__navigation,
.v-pagination .v-pagination__item {
  background-color: #ffffff !important;
  color: 000000 !important;
}

.v-pagination .v-pagination__item--active {
  background-color: var(--v-accent-base) !important;
  color: #ffffff !important;
}

.v-pagination .v-icon {
  color: #000000 !important;
  font-size: 14px;
}

@media screen and (min-width: 1200px) {
  .container {
    max-width: 1194px !important;
  }
}
</style>
